import { Type } from 'class-transformer';

export class WorkflowInfo {
    payee: string;
    payeeCode: string;
    managementCompanyVendorId: number;
    invoiceNumber: string;

    @Type(() => Date)
    invoiceDate: Date;

    @Type(() => Date)
    dueDate: Date;
    invoiceAmount: number;
    vendorAccountNumber: string;

    @Type(() => Date)
    postDate: Date;

    specialHandling: string;
    isEFTAccount: boolean;
    description: string;
    bankAccount: string;
    workflowId: number;
}
